// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable no-param-reassign */
import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { Chip } from 'components';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Formik } from 'formik';
import { DefaultSelect } from 'components/Form';
import './FilteredTabs.scss';

export default class FilteredTabs extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {
    const {
      border,
      className,
      content,
      alignment,
      size,
      activeFilter,
    } = this.props;
    const allTabs = [...content[0], ...content[1]];
    const selectOptions = allTabs.map(tab => ({
      label: `${tab.tabNameReadable || tab.tabName} (${tab.count})`,
      value: tab.tabName,
      onChange: tab.onChange,
    }));
    const defaultSelectOption = selectOptions.find(
      option => option.value === activeFilter
    );

    return (
      <>
        <div className="filtered-tabs--mobile">
          <Formik>
            <DefaultSelect
              name="statusSelector"
              options={selectOptions}
              defaultValue={defaultSelectOption}
              hideValidationStyling
              onChange={e => {
                if (e !== '') {
                  selectOptions.find(option => option.value === e).onChange();
                }
              }}
            />
          </Formik>
        </div>
        <div
          className={classnames(
            'filtered-tabs filtered-tabs--desktop',
            className,
            { 'bordered-bottom': border === 'bottom' },
            { 'bordered-top': border === 'top' },
            { 'filtered-tabs-sm': size === 'sm' },
            { 'filtered-tabs-lg': size === 'lg' }
          )}
        >
          <div className={classnames('tabs-wrap', alignment)}>
            <Nav tabs className={classnames({})}>
              {content[0].map((item, index) => (
                <NavItem key={`${1 + index}.link`}>
                  {item.tabName && (
                    <NavLink
                      className={classnames({
                        active: activeFilter === item.tabName,
                      })}
                      onClick={e => {
                        if (item.tabName !== '') {
                          item.onChange();
                          e.stopPropagation();
                        }
                      }}
                      tag="button"
                      type="button"
                    >
                      {item.tabNameReadable || item.tabName}
                      <Chip size="sm" className="rounded-circle" color="light">
                        {item.count}
                      </Chip>
                    </NavLink>
                  )}
                </NavItem>
              ))}
            </Nav>
            <Nav tabs className={classnames({})}>
              {content[1].map((item, index) => (
                <NavItem key={`${1 + index}.link`}>
                  {item.tabName && (
                    <NavLink
                      className={classnames({
                        active: activeFilter === item.tabName,
                      })}
                      onClick={e => {
                        if (item.tabName !== '') {
                          item.onChange();
                          e.stopPropagation();
                        }
                      }}
                      tag="button"
                      type="button"
                    >
                      {item.tabName}
                      <Chip size="sm" className="rounded-circle" color="light">
                        {item.count}
                      </Chip>
                    </NavLink>
                  )}
                </NavItem>
              ))}
            </Nav>
          </div>
        </div>
      </>
    );
  }
}

FilteredTabs.propTypes = {
  border: PropTypes.oneOf(['default', 'top', 'bottom']),
  className: PropTypes.string,
  activeFilter: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        tabName: PropTypes.string,
        callbackFunc: PropTypes.func,
      })
    )
  ).isRequired,
  alignment: PropTypes.string,
  size: PropTypes.oneOf([null, 'sm', 'lg']),
};

FilteredTabs.defaultProps = {
  border: 'default',
  className: '',
  alignment: '',
  size: null,
};

/* eslint-enable no-param-reassign */
